import axios, { Method, ResponseType } from 'axios';

export const callBFF = async <T>(
  method: Method,
  path: string,
  data?: object,
  responseType: ResponseType = 'json',
): Promise<T> => {
  return axios
    .request({
      method,
      url: `/api/${path}`,
      data: { ...data },
      withCredentials: true,
      responseType,
    })
    .then((response) => response.data)
    .catch((error) => {
      if (error.response?.status === 401) {
        // TODO : replace by StorageHelper (if possible)
        localStorage.removeItem('_SPO_is_authenticated');
        globalThis.location.reload();
        return Promise.resolve({
          data: null,
          status: 401,
          statusText: 'Unauthorized',
          headers: {},
          config: error.config,
        });
      }
      throw new Error(error.response?.statusText ?? 'An error just occurred');
    });
};
